import {take, put} from 'redux-saga/effects';
import {ROUTE_UNMOUNT_SIDE_EFFECT_COMPLETED} from '@computerrock/formation-router';
import {efServiceAssignmentTypes} from '@ace-de/eua-entity-types';
import updateServiceCase from '../../service-cases/sagas/updateServiceCase';
import updateServiceAssignment from '../../service-assignments/sagas/updateServiceAssignment';
import * as samcActionTypes from '../samcActionTypes';

/**
 * Update SAMC damage location info
 */
const updateSAMCDamageLocationInfo = function* updateSAMCDamageLocationInfo() {
    while (true) {
        const {payload} = yield take(samcActionTypes.SUBMIT_SAMC_DAMAGE_LOCATION_INFO_FORM);
        const {serviceCaseData, serviceCaseId, serviceAssignmentData, serviceAssignmentLineNo, caseType} = payload;

        if (serviceCaseData) {
            yield* updateServiceCase({
                caller: samcActionTypes.SUBMIT_SAMC_DAMAGE_LOCATION_INFO_FORM,
                caseType: caseType,
                serviceCaseId,
                serviceCaseData,
            });
        }

        yield* updateServiceAssignment({
            caller: samcActionTypes.SUBMIT_SAMC_DAMAGE_LOCATION_INFO_FORM,
            assignmentType: efServiceAssignmentTypes.MEDICAL_CLEARANCE,
            serviceAssignmentLineNo,
            serviceCaseId,
            serviceAssignmentData,
        });

        yield put({
            type: ROUTE_UNMOUNT_SIDE_EFFECT_COMPLETED,
            payload: {caller: samcActionTypes.SUBMIT_SAMC_DAMAGE_LOCATION_INFO_FORM},
        });
    }
};

export default updateSAMCDamageLocationInfo;
